module.exports = __webpack_public_path__ + "static/media/boogii.782f8da8.png";